/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Scope_Detail5Inputs */

const en_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should the AI do, and where does it hand off to a human?`)
};

const ar_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماذا يجب أن يفعل الذكاء الاصطناعي، وأين يُسلَّم إلى إنسان؟`)
};

const bn_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI কী করবে, আর কোথায় মানুষের কাছে হস্তান্তর করবে?`)
};

const de_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was soll die KI tun, und wo übergibt sie an einen Menschen?`)
};

const es_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué debe hacer la IA y dónde deriva a un humano?`)
};

const fr_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que doit faire l'IA, et où transmet-elle à un humain ?`)
};

const pt_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que a IA deve fazer e onde ela passa o caso a uma pessoa?`)
};

const zh_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工智能应该做什么，在哪里将其交给人类？`)
};

const tr_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ ne yapmalı, nerede insana devredilmeli?`)
};

const ru_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что должен делать ИИ и где задача переходит человеку?`)
};

const pl_svc_ai_integration_scope_detail5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co powinna zrobić sztuczna inteligencja i gdzie przekazuje ją człowiekowi?`)
};

/**
* | output |
* | --- |
* | "What should the AI do, and where does it hand off to a human?" |
*
* @param {Svc_Ai_Integration_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_scope_detail5 = /** @type {((inputs?: Svc_Ai_Integration_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_ai_integration_scope_detail5(inputs)
	if (locale === "de") return de_svc_ai_integration_scope_detail5(inputs)
	if (locale === "es") return es_svc_ai_integration_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_ai_integration_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_ai_integration_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_ai_integration_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_ai_integration_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_ai_integration_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_ai_integration_scope_detail5(inputs)
	return en_svc_ai_integration_scope_detail5(inputs)
});
export { svc_ai_integration_scope_detail5 as "svc_ai-integration_SCOPE_detail" }